module.exports = __webpack_public_path__ + "static/media/social.2aaf633c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/social.svg
// module id = 2462
// module chunks = 0